/// <reference path="../../TypeLite.Net4.d.ts" />
import { action } from 'typesafe-actions'
import { ServicePageActionTypes } from './types'

export const fetchRequestService = (code: string, filter: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter) => action(ServicePageActionTypes.FETCH_REQUEST_Service, { code: code, filter: filter})
export const fetchSuccessService = (data: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ServiceModel) => action(ServicePageActionTypes.FETCH_SUCCESS_Service, data)

